(function() {
  'use strict';

  function getUkNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    var map = {};
    parts.forEach(function(part) {
      if (part.type !== 'literal') map[part.type] = part.value;
    });
    return new Date(
      parseInt(map.year, 10),
      parseInt(map.month, 10) - 1,
      parseInt(map.day, 10),
      parseInt(map.hour, 10),
      parseInt(map.minute, 10),
      parseInt(map.second, 10)
    );
  }

  function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function isWeekend(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }

  function addWorkingDays(date, daysToAdd) {
    var result = startOfDay(date);
    var remaining = parseInt(daysToAdd, 10);
    if (isNaN(remaining) || remaining < 1) remaining = 1;
    var added = 0;

    while (added < remaining) {
      result.setDate(result.getDate() + 1);
      if (!isWeekend(result)) {
        added++;
      }
    }
    return result;
  }

  function getDispatchDate(now, afterCutoff) {
    var dispatch = startOfDay(now);
    if (afterCutoff) {
      dispatch.setDate(dispatch.getDate() + 1);
    }
    while (isWeekend(dispatch)) {
      dispatch.setDate(dispatch.getDate() + 1);
    }
    return dispatch;
  }

  function getNextCutoff(now, cutoffHour, cutoffMinute) {
    var candidate = new Date(now.getTime());
    candidate.setHours(cutoffHour, cutoffMinute, 0, 0);
    if (now >= candidate) {
      candidate.setDate(candidate.getDate() + 1);
      candidate.setHours(cutoffHour, cutoffMinute, 0, 0);
    }
    return candidate;
  }

  function calculateDeliveryDate(daysToAdd, afterCutoff) {
    var now = getUkNow();
    var dispatch = getDispatchDate(now, afterCutoff);
    var delivery = addWorkingDays(dispatch, daysToAdd);
    var tomorrow = startOfDay(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return {
      date: delivery,
      isTomorrow: delivery.getTime() === tomorrow.getTime()
    };
  }

  function formatDateWithSuffix(date, isTomorrow) {
    var day = date.getDate();
    var suffix = 'th';
    if (day % 100 < 11 || day % 100 > 13) {
      switch (day % 10) {
        case 1: suffix = 'st'; break;
        case 2: suffix = 'nd'; break;
        case 3: suffix = 'rd'; break;
      }
    }

    if (isTomorrow) {
      return 'Tomorrow, ' + day + suffix + ' ' + date.toLocaleDateString('en-GB', { month: 'short' });
    }
    return date.toLocaleDateString('en-GB', { weekday: 'long' }) + ', ' + day + suffix + ' ' + date.toLocaleDateString('en-GB', { month: 'short' });
  }

  function initDeliveryBlocks() {
    var blocks = document.querySelectorAll('.delivery-info-wrapper[data-initialized="false"]');

    blocks.forEach(function(block) {
      block.setAttribute('data-initialized', 'true');

      var timerEl = block.querySelector('.countdown-timer');
      var dateEl = block.querySelector('.delivery-date');
      if (!timerEl || !dateEl) return;

      var cutoffTime = block.getAttribute('data-cutoff-time') || '17:00';
      var daysToAdd = parseInt(block.getAttribute('data-delivery-days'), 10);
      if (isNaN(daysToAdd) || daysToAdd < 1) daysToAdd = 1;

      var parts = cutoffTime.split(':');
      var cutoffHour = parseInt(parts[0], 10);
      var cutoffMinute = parseInt(parts[1], 10);
      if (isNaN(cutoffHour)) cutoffHour = 17;
      if (isNaN(cutoffMinute)) cutoffMinute = 0;

      function updateDisplay() {
        var now = getUkNow();
        var afterCutoff = (now.getHours() > cutoffHour) ||
          (now.getHours() === cutoffHour && now.getMinutes() >= cutoffMinute);

        var nextCutoff = getNextCutoff(now, cutoffHour, cutoffMinute);
        var diff = nextCutoff.getTime() - now.getTime();
        if (diff > 0) {
          var hours = Math.floor(diff / 3600000);
          var minutes = Math.floor((diff % 3600000) / 60000);
          var seconds = Math.floor((diff % 60000) / 1000);
          timerEl.textContent = String(hours).padStart(2, '0') + ':' +
            String(minutes).padStart(2, '0') + ':' +
            String(seconds).padStart(2, '0');
        } else {
          timerEl.textContent = '00:00:00';
        }

        var deliveryInfo = calculateDeliveryDate(daysToAdd, afterCutoff);
        dateEl.textContent = formatDateWithSuffix(deliveryInfo.date, deliveryInfo.isTomorrow);
      }

      updateDisplay();
      setInterval(updateDisplay, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryBlocks);
  } else {
    initDeliveryBlocks();
  }

  if (document.body) {
    var observer = new MutationObserver(function() {
      if (document.querySelector('.delivery-info-wrapper[data-initialized="false"]')) {
        initDeliveryBlocks();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      document.querySelectorAll('.delivery-info-wrapper').forEach(function(el) {
        el.setAttribute('data-initialized', 'false');
      });
      setTimeout(initDeliveryBlocks, 100);
    });
    document.addEventListener('shopify:block:select', function() {
      setTimeout(initDeliveryBlocks, 100);
    });
  }
})();
